import _get from 'lodash/get';
import APPCONFIG from '../../../constants/Config';
import {
  UPDATE_LIST_LAST_PARAMS,
} from '../../../constants/ActionTypes';

const initialSettings = APPCONFIG.pageSize;
const pageSize = (state = initialSettings, action) => {
  switch (action.type) {
    // UPDATE LAST PARAMS
    case UPDATE_LIST_LAST_PARAMS:
      if (!action.reinit) {
        return {
          ...state,
          [action.target]: _get(action, 'pagination.pageSize', state[action.target]),
        };
      }
      return state;
    default:
      return state;
  }
};

export default pageSize;



// WEBPACK FOOTER //
// ./reducers/app/list/pageSize.js